module.exports = __webpack_public_path__ + "media/images/meta/clubpilates/apple-touch-icon_aqua-153c605939335df9f418cf160fc09d05.png";